export default __webpack_public_path__ + "locales/el-GR/Errors.json?hash=ecedf2d278ee81d507eb367fadd786a5";